module.exports = __webpack_public_path__ + "img/answer-c1-5.cac37d78.png";